import React, { useEffect, useState } from 'react';
import moment from 'moment';

import Loader from '@/components/Loader';
import { loadPaymentsScheduleData } from '@/services/finance/finance-service';
import { PaymentsScheduleResponseConverted } from '@/services/finance/typings';
import {
  Component,
  Row,
  RowItem,
  RowTitle,
  Table,
  Title,
} from '@/components/modals/CreditPaymentsSheduleModal/common.styles';
import { useLockBodyScroll } from '@/hooks/useLockBodyScroll';
import CloseButton from '@/components/modals/shared/CloseButton';

import { PaymentsScheduleModalProps } from './types';
import { getPaymentsSum, handleConvertPaymentsSchedule } from './helpers';

function PaymentsScheduleModal({
  innerProps,
  closeModal,
}: PaymentsScheduleModalProps) {
  const { paymentsScheduleConfig, onCloseButton } = innerProps;

  const [isLoading, setLoading] = useState<boolean>(true);
  const [paymentsSchedule, setPaymentsSchedule] = useState<
    PaymentsScheduleResponseConverted[]
  >([]);

  useLockBodyScroll();

  useEffect(() => {
    (async () => {
      try {
        const paymentsSchedule = await loadPaymentsScheduleData(
          paymentsScheduleConfig
        );

        setPaymentsSchedule(handleConvertPaymentsSchedule(paymentsSchedule));
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [paymentsScheduleConfig]);

  return (
    <Component>
      <CloseButton
        onClick={() => {
          closeModal();
          onCloseButton?.();
        }}
      />

      {isLoading ? (
        <Loader />
      ) : (
        <React.Fragment>
          <Title>График платежей</Title>

          <Table>
            <Row isHeaderRow withBackground>
              <RowItem colCount={2}>
                <RowTitle isHeaderTitle>Месяц</RowTitle>
              </RowItem>

              <RowItem colCount={2}>
                <RowTitle isHeaderTitle>Платеж</RowTitle>
              </RowItem>
            </Row>

            {paymentsSchedule &&
              paymentsSchedule.length > 0 &&
              paymentsSchedule.map(({ year, payments }, index) => (
                <React.Fragment key={index}>
                  <Row>
                    <RowItem colCount={1}>
                      <RowTitle isYearTitle>{year}</RowTitle>
                    </RowItem>
                  </Row>
                  {payments &&
                    payments.length > 0 &&
                    payments.map(({ month, payment }, index) => (
                      <React.Fragment key={index}>
                        <Row withBackground={index % 2 === 0}>
                          <RowItem colCount={2}>
                            <RowTitle>{moment.months(month - 1)}</RowTitle>
                          </RowItem>

                          <RowItem colCount={2}>
                            <RowTitle>{payment}</RowTitle>
                          </RowItem>
                        </Row>
                      </React.Fragment>
                    ))}
                </React.Fragment>
              ))}

            <Row isHeaderRow withBackground>
              <RowItem colCount={2}>
                <RowTitle isHeaderTitle>Итого</RowTitle>
              </RowItem>

              <RowItem colCount={2}>
                <RowTitle isHeaderTitle>
                  {getPaymentsSum(paymentsSchedule)}
                </RowTitle>
              </RowItem>
            </Row>
          </Table>
        </React.Fragment>
      )}
    </Component>
  );
}

export default PaymentsScheduleModal;
